import { StyleBoxLabels } from '../types/morningstar.types';

/**
 * Default labels for the Morningstar Style Box
 */
export const DEFAULT_LABELS: Readonly<StyleBoxLabels> = {
  marketCap: 'Market Capitalization',
  investmentStyle: 'Investment Style',
  marketCapValues: ['Large', 'Mid', 'Small'],
  investmentStyleValues: ['Value', 'Blend', 'Growth'],
} as const;
